import {
    __,
    assoc,
    chain,
    compose,
    concat,
    flip,
    head,
    groupWith,
    identity,
    map,
    prepend,
    prop,
    propOr,
    unnest,
    useWith
} from 'ramda';

import { mapIndexed } from 'utils/ramdaAdditions';
import evolve from './evolve';
import { documentType, education, partsInProject } from './commonMapper';
import EventMapper from './eventMapper';
import PersonMapper from './personMapper';

const DISABLED_EVENTS_STATUSES = {
    6: 'annul',
    7: 'archive',
    9: 'completed'
};

const getData = propOr([]);
const getUserIds = map(prop('id'));

export const createGetWorksheetItems = groupName => {
    const addIndex = mapIndexed(flip(assoc('number')));
    const getGroup = assoc('group', __, { groupType: 'group' });
    const addGroup = useWith(prepend, [compose(getGroup, prop(groupName)), identity]);
    const getGroups = groupWith((a, b) => a[groupName] === b[groupName]);

    return compose(unnest, map(chain(addGroup, head)), map(addIndex), getGroups);
};

const getWorksheetItems = createGetWorksheetItems('groupName');

const workplace = (workplace = {}) => {
    const { company, dateFrom : beginWork, dateTo : endWork } = workplace;
    const work = PersonMapper.work({ beginWork, endWork });

    return `${company} ${work.experience} ${work.stillWorks}`;
};

export default (list) => {
    const evolvedList = evolve({
        people: {
            workplace: workplace,
            documents: documentType,
            education: education,
            partsInProject: partsInProject,
            working: { text: EventMapper.text }
        }
    })(list);

    const participators = getUserIds(getData('participators', list));
    const responsible = getUserIds(getData('responsible', list));

    return {
        ...evolvedList,
        eventsDisabled: evolvedList.project.status in DISABLED_EVENTS_STATUSES,
        eventsUsersIds: concat(participators, responsible),
        people: getWorksheetItems(getData('people', evolvedList))
    };
};
